@if(isTestMode) {
<div class="test-app-warning-border-top"></div>
<div class="test-app-warning-border-left"></div>
<div class="test-app-warning-border-right"></div>
<div class="test-app-warning-border-bottom"></div>
}
<main class="app-main" [ngClass]="{ 'TEST-MODE': isTestMode }">
  <pm-cookies-dialog (settingsSaved)="onCookiesSettingsSaved()" />
  @if (isAppDisabled) {
  <pm-app-disabled-dialog />
  }
  <router-outlet></router-outlet>
  <!-- @if (isDev) {
    <theme-selector class="theme-selector" />
  } -->
</main>

<p-toast
  key="error-message"
  position="bottom-right"
  [breakpoints]="{
    '920px': { width: '90%', right: '0', left: '0', 'margin-left': 'auto', 'margin-right': 'auto' },
  }"
/>
<p-toast
  key="success-message"
  position="bottom-right"
  [breakpoints]="{
    '920px': { width: '90%', right: '0', left: '0', 'margin-left': 'auto', 'margin-right': 'auto' },
  }"
/>
